import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.1826 1.6499V3.66657",
			stroke: "#FF555F",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5156 6.4165L15.7656 6.4165M3.84896 6.4165L6.59896 6.4165M15.7656 6.4165L6.59896 6.4165M15.7656 6.4165V6.4165C15.7656 4.89772 14.5344 3.66651 13.0156 3.66651L9.34896 3.66651C7.83017 3.66651 6.59896 4.89772 6.59896 6.4165V6.4165",
			stroke: "#FF555F",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4163 9.16651V12.7498C17.4163 16.6987 15.1499 19.2498 10.9997 19.2498C6.8494 19.2498 4.58301 16.6987 4.58301 12.7498L4.58301 9.1665",
			stroke: "#FF555F",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16699 11V13.75M12.8337 11V13.75",
			stroke: "#FF555F",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
